// Alert devtools mock data
import {
  InsuranceBillAlert,
  Alerts,
  PaymentMethodAlert,
} from "../../types/Alerts.types";
import { ESignDocument } from "../../types/ESignDocument.types";

const insuranceCoreAutopayFailed: InsuranceBillAlert[] = [
  {
    source: "core",
    policyNumber: "abc123",
    state: "CA",
    country: "USA",
  },
];

const insuranceApexAutopayFailed: InsuranceBillAlert[] = [
  {
    source: "apex",
    policyNumber: "en01",
    state: "MI",
    country: "USA",
  },
];

const insuranceAutopayFailed: InsuranceBillAlert[] = [
  ...insuranceCoreAutopayFailed,
  ...insuranceApexAutopayFailed,
];

const insuranceCoreBillPastDue: InsuranceBillAlert[] = [
  {
    source: "core",
    policyNumber: "def456",
    state: "OR",
    country: "USA",
  },
];

const insuranceApexBillPastDue: InsuranceBillAlert[] = [
  {
    source: "apex",
    policyNumber: "en02",
    state: "IL",
    country: "USA",
  },
];

const insuranceBillPastDue: InsuranceBillAlert[] = [
  ...insuranceCoreBillPastDue,
  ...insuranceApexBillPastDue,
];

const eSignDocuments: ESignDocument[] = [
  {
    id: 1,
    source: "usa",
    state: "KS",
  },
  {
    id: 2,
    source: "canada",
    state: "OK",
  },
];

const paymentMethodCoreAlert: PaymentMethodAlert[] = [
  {
    source: "core",
    policyNumber: "abc123",
    last4: "1234",
    cardType: "Visa",
  },
];

const paymentMethodApexAlert: PaymentMethodAlert[] = [
  {
    source: "apex",
    policyNumber: "en02",
    last4: "5678",
    cardType: "Mastercard",
  },
];

const paymentMethodAlert: PaymentMethodAlert[] = [
  ...paymentMethodCoreAlert,
  ...paymentMethodApexAlert,
];

export const insuranceCoreAutopayAlert: Alerts = {
  insuranceAutopayFailed: insuranceCoreAutopayFailed,
};

export const insuranceApexAutopayAlert: Alerts = {
  insuranceAutopayFailed: insuranceApexAutopayFailed,
};

export const insuranceAutopayAlert: Alerts = {
  insuranceAutopayFailed,
};

export const insuranceCoreBillPastDueAlert: Alerts = {
  insuranceBillPastDue: insuranceCoreBillPastDue,
};

export const insuranceApexBillPastDueAlert: Alerts = {
  insuranceBillPastDue: insuranceApexBillPastDue,
};

export const insuranceBillPastDueAlert: Alerts = {
  insuranceBillPastDue,
};

export const hdcAutopayAlert: Alerts = {
  hdcAutopayFailed: true,
};

export const hdcBillPastDueAlert: Alerts = {
  hdcBillPastDue: true,
};

export const eSignAlert: Alerts = {
  eSignDocuments: [eSignDocuments[0]],
};

export const twoEsignAlert: Alerts = {
  eSignDocuments,
};

export const twoEsignInsuranceAutopayFailureHdcLatePaymentAlert: Alerts = {
  insuranceAutopayFailed,
  hdcBillPastDue: true,
  eSignDocuments: eSignDocuments,
};

export const paymentMethodExpiredCoreAlert: Alerts = {
  paymentMethodExpired: paymentMethodCoreAlert,
};

export const paymentMethodExpiredApexAlert: Alerts = {
  paymentMethodExpired: paymentMethodApexAlert,
};

export const paymentMethodExpiredAlert: Alerts = {
  paymentMethodExpired: paymentMethodAlert,
};

export const paymentMethodExpiringCoreAlert: Alerts = {
  paymentMethodExpiring: paymentMethodCoreAlert,
};

export const paymentMethodExpiringApexAlert: Alerts = {
  paymentMethodExpiring: paymentMethodApexAlert,
};

export const paymentMethodExpiringAlert: Alerts = {
  paymentMethodExpiring: paymentMethodAlert,
};

export const mockAlerts: Alerts[] = [
  {}, // no alerts
  insuranceCoreAutopayAlert,
  insuranceApexAutopayAlert,
  insuranceAutopayAlert,
  insuranceCoreBillPastDueAlert,
  insuranceApexBillPastDueAlert,
  insuranceBillPastDueAlert,
  hdcAutopayAlert,
  hdcBillPastDueAlert,
  eSignAlert,
  twoEsignAlert,
  twoEsignInsuranceAutopayFailureHdcLatePaymentAlert,
  paymentMethodExpiredCoreAlert,
  paymentMethodExpiredApexAlert,
  paymentMethodExpiredAlert,
  paymentMethodExpiringCoreAlert,
  paymentMethodExpiringApexAlert,
  paymentMethodExpiringAlert,
];
